import { TourKeys } from '@cast/constants';

import { useTourStepId } from 'core/tour-v2/hooks/useTourStepId';
import {
  useClusterOptimizationsQuery as useClusterOptimizationsQueryBase,
  type ClusterOptimizationsQueryArgs,
} from '@cast/features-cluster-shared';

type Args = Omit<ClusterOptimizationsQueryArgs, 'tourStepId'>;

export const useClusterOptimizationsQuery = (args: Args = {}) => {
  const tourStepId = useTourStepId(TourKeys.OpinionatedPlatform);

  return useClusterOptimizationsQueryBase({
    ...args,
    tourStepId,
  });
};
